// -　絞り込み・並び替え -----------------------------------
$(function(){
  $('.panel-heading').on('click', function() {   
    $('.panel-body,.list-filter-menu-btn').toggleClass('open');
  });

  var parent = $('.lists-toggle');
  parent.each(function(){
    var self = $(this);
    self.on('click',function(){
      parent.not(self).next().slideUp(300);
      self.next().slideToggle(300);
    });
  });

  //console.log('archive-page');
});

